module.exports = __webpack_public_path__ + "img/ywt_list_img8.5b1ef93.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/saasIntroduction/ywt_list_img8.png
// module id = hzvA
// module chunks = 136